// Package Configuration
export const PACKAGES = [
  { value: '10', label: '10 USDT', wei: '10000000000000000000' },
  { value: '50', label: '50 USDT', wei: '50000000000000000000' },
  { value: '100', label: '100 USDT', wei: '100000000000000000000' },
  { value: '200', label: '200 USDT', wei: '200000000000000000000' },
  { value: '300', label: '300 USDT', wei: '300000000000000000000' },
  { value: '400', label: '400 USDT', wei: '400000000000000000000' },
  { value: '500', label: '500 USDT', wei: '500000000000000000000' },
  { value: '1000', label: '1000 USDT', wei: '1000000000000000000000' }
];

export const POSITIONS = {
  LEFT: 0,
  RIGHT: 1
};

export const ACTIVITY_TYPES = {
  1: { name: 'Binary', icon: '⚡', color: '#A855F7' },
  2: { name: 'Referral', icon: '👥', color: '#00F0FF' },
  3: { name: 'Withdraw', icon: '💰', color: '#22C55E' },
  4: { name: 'ROI', icon: '📈', color: '#FF006E' }
};

// Contract root user (owner, created in the Storage constructor). Never shown as an ID.
export const ROOT_ID = 1000;

// Default sponsor for users without a referral link = admin wallet 0xD5eF...Ce00
export const DEFAULT_REFERRER_ID = 3969424;

export const isRootId = (id) => Number(id) === ROOT_ID;
